import { isEqual } from "lodash";
import { useEffect } from "react";
import { useUpdatedRef } from "./useUpdatedRef";

export const useOnObjectChanged = <T>(
  object: T,
  callback: (object: T) => void,
) => {
  const previousObject = useUpdatedRef(object).current;
  const callbackRef = useUpdatedRef(callback);

  useEffect(() => {
    if (!isEqual(previousObject, object)) {
      callbackRef.current(object);
    }
  }, [object, previousObject, callbackRef]);
};
